<template>
  <div v-if="trade" class="prediction-card">
    <IconComponent
      class="iconDv remove-icon c-pointer"
      @click="onRemove()"
      @touchstart="onRemove()"
      :id="`minusWining${index}`"
      v-if="showRemove"
      icon="minus.svg"
    />
    <span class="card--tag color-bright-blue taginfoDv">{{
      $t("profileDetails.headings.predictions")
    }}</span>
    <div class="StatusInfoDv">
      <h2 v-if="predictionType === 'Long'">
        {{ $t("profileDetails.labels.Long") }}
      </h2>
      <h2 class="infoNegative" v-if="predictionType === 'Short'">
        {{ $t("profileDetails.labels.Short") }}
      </h2>
      <h4></h4>
      <h3>
        {{
          trade.isOpen
            ? $t("profileDetails.labels.Open")
            : $t("profileDetails.labels.Closed")
        }}
      </h3>
    </div>
    <div class="prediction-card-body">
      <div class="signalHeader">
        <div class="firstDv">
          <StockImageTag
            :disableRouting="disableRouting"
            :stockId="trade.stockId"
            :imgUrl="trade.logoUrl"
            :symbol="trade.symbol"
            :market="trade.type || trade.market"
            :key="trade.stockId"
          />
          <div class="textDv">
            <div class="symbol-with-info">
              <h2>{{ trade.symbol ?? "-" }}</h2>
              <el-tooltip
                class="prediction-info-tooltip"
                effect="dark"
                content="Prediction made will be realized on day end"
                placement="bottom-start"
                :popper-style="{
                  background: 'var(--base-darkest)',
                  color: 'var(--base-text)',
                  width: '130px',
                  fontSize: '10px',
                  padding: '5px',
                  borderRadius: '4px',
                  border: 'none',
                }"
              >
                <IconComponent class="info-icon" icon="info-circle.svg" />
              </el-tooltip>
            </div>

            <el-tooltip
              class="box-item"
              effect="dark"
              :content="trade.name ?? '-'"
              placement="top-start"
              :popper-style="{
                background: 'var(--base-darkest)',
                color: 'var(--text-color)',
                fontSize: '10px',
                padding: '4px',
                borderRadius: '4px',
                border: 'none',
              }"
            >
              <p>{{ trade.name ?? "-" }}</p>
            </el-tooltip>
          </div>
        </div>
        <div class="endDv" v-if="stock">
          <div class="lastDv">
            <h2
              class="whiteDoler"
              ref="priceElement"
              v-html="
                $filters.systemNumberConvention(
                  stock.price,
                  true,
                  false,
                  widthCalculating
                )
              "
            ></h2>
            <div
              :class="{
                downward: stock.changesPercentage < 0,
              }"
              class="informationGridWatchlistViewDv"
            >
              <el-tooltip
                class="box-item"
                effect="dark"
                :content="'$' + stock.change"
                placement="top-start"
              >
                <div>
                  <IconComponent
                    class="priceIcon"
                    icon="stock-pricing-up-icon.svg"
                  />
                  {{
                    Math.abs(
                      $filters.systemNumberConvention(
                        stock.changesPercentage,
                        false
                      )
                    )
                  }}%
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
      <div class="price-target-card" v-if="stock">
        <div class="price-info">
          <div class="entry">
            <p class="label">{{ $t("profileDetails.labels.EntryPrice") }}</p>
            <p
              class="price"
              v-html="
                $filters.systemNumberConvention(
                  samePriceAsCurrent ? stock?.price : trade.price,
                  true,
                  false,
                  300
                )
              "
            ></p>
            <p class="date">
              {{ $filters.formatDateTwo(trade.tradeDate, "MMM DD, YYYY") }}
            </p>
          </div>

          <div
            class="change"
            :class="{
              positive:
                $filters.systemAccuracyPercentage(entryChange, 100) >= 50,
            }"
          >
            <span
              v-html="$filters.systemAccuracyPercentage(entryChange, 100)"
            ></span
            >%
          </div>

          <div class="target">
            <p class="label">{{ $t("profileDetails.labels.TargetPrice") }}</p>
            <p
              class="price"
              v-html="
                $filters.systemNumberConvention(
                  trade.predicition.price,
                  true,
                  false,
                  300
                )
              "
            ></p>
            <p class="date">
              {{
                $filters.formatToMonthDay(
                  trade.predicition.date,
                  "MMM DD, YYYY"
                )
              }}
            </p>
          </div>
        </div>
        <div class="progress-container">
          <div class="progress-bar">
            <div
              class="progress"
              :style="{ width: `calc(100% - ${PredictionAccuracy}%)` }"
            ></div>
            <div
              class="progress-label"
              ref="progressLabelRef"
              :style="progressLabelStyle"
            >
              <el-tooltip
                class="box-item"
                effect="dark"
                :content="'$' + PredictionCurrentLivePrice"
                placement="top-start"
              >
                <div class="label-content">
                  <span
                    class="percentage"
                    v-html="
                      $filters.systemNumberConvention(
                        PredictionAccuracy,
                        false,
                        true,
                        100
                      ) + '%'
                    "
                  ></span>
                  <span class="date" v-if="trade.realizedDate"
                    >({{
                      $filters.formatDateTwo(
                        trade.realizedDate,
                        "MMM DD, YYYY"
                      )
                    }})</span
                  >
                </div>
              </el-tooltip>
            </div>
          </div>
          <div class="progress-scale">
            <span>0%</span>
            <span>50%</span>
            <span>100%</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="prediction-card" v-if="false && trade">
    <IconComponent
      class="iconDv c-pointer"
      @click="onRemove()"
      @touchstart="onRemove()"
      :id="`minusWining${index}`"
      v-if="showRemove"
      icon="minus.svg"
    />
    <span class="card--tag color-purple taginfoDv">{{
      $t("profileDetails.headings.predictions")
    }}</span>
    <div class="StatusInfoDv">
      <h2>{{ predictionType }}</h2>
      <h4></h4>
      <h3>{{ trade.isOpen ? "Open" : "Closed" }}</h3>
    </div>
    <div class="PredictionBodyDv">
      <div class="FirstInfoDv">
        <StockImageTag
          :disableRouting="disableRouting"
          :stockId="trade.stockId"
          :imgUrl="trade.logoUrl"
          :symbol="trade.symbol"
          :market="trade.type || trade.market"
          :key="trade.stockId"
        />
        <div class="textDv">
          <el-tooltip
            class="box-item"
            effect="dark"
            :content="trade.symbol"
            placement="top-start"
            v-if="isOverflowing"
          >
            <h1 ref="tradeSymbol">{{ trade.symbol ?? "-" }}</h1>
          </el-tooltip>
          <h1 ref="tradeSymbol" v-else>{{ trade.symbol ?? "-" }}</h1>

          <div class="secondDv" v-if="stock">
            <el-tooltip
              class="box-item"
              effect="dark"
              :content="stock.name"
              placement="top-start"
              v-if="isSymbolOverflowing"
            >
              <p ref="symbolTitle" class="symbolTitle">
                {{ stock.name ?? "-" }}
              </p>
            </el-tooltip>
            <p v-else ref="symbolTitle" class="symbolTitle">
              {{ stock.name ?? "-" }}
            </p>
          </div>
        </div>
      </div>
      <div class="SecondInfoDv">
        <div class="EntryPriceDv">
          <h2>{{ $t("profileDetails.labels.Entry") }}:</h2>
          <p
            v-html="
              $filters.systemNumberConvention(
                samePriceAsCurrent ? stock?.price : trade.price,
                true,
                false,
                widthCalculating
              )
            "
          ></p>
          <div
            style="
              display: flex;
              justify-content: flex-end;
              align-items: center;
            "
          >
            <IconComponent
              :class="{ negative: entryChange < 0 }"
              class="priceIcon"
              icon="stock-pricing-up-icon.svg"
            />
            <h3
              v-html="
                $filters.systemNumberConvention(entryChange, false, true, 100)
              "
              :class="{ negative: entryChange < 0 }"
            ></h3>
            <h3 :class="{ negative: entryChange < 0 }">%</h3>
          </div>
        </div>
        <div class="TargetPriceDv">
          <h2>{{ $t("profileDetails.labels.Target") }}</h2>
          <p
            v-html="
              $filters.systemNumberConvention(
                trade.predicition.price,
                true,
                false,
                widthCalculating
              )
            "
          ></p>
          <div
            style="
              display: flex;
              justify-content: flex-end;
              align-items: center;
            "
            class="accuracy"
            :class="{
              low: PredictionAccuracy <= 20,
              medium: PredictionAccuracy > 20 && PredictionAccuracy <= 60,
              high: PredictionAccuracy > 60,
            }"
          >
            <IconComponent icon="icon-accuracy.svg" />
            <h3
              v-html="
                $filters.systemNumberConvention(
                  PredictionAccuracy,
                  false,
                  true,
                  100
                ) + '%'
              "
            ></h3>
          </div>
        </div>
      </div>
    </div>
    <div class="PredictionchartDv">
      <apexchart
        :type="chartType"
        height="100%"
        width="100%"
        ref="chart"
        :options="chartOptions"
        :series="series"
      >
      </apexchart>
    </div>
    <div class="PredictionFooterDv">
      <h2>{{ $filters.formatDateTwo(trade.tradeDate) }}</h2>
      <h2>< {{ totalDays }} D></h2>
      <h2>{{ $filters.formatDateTwo(trade.predicition.date) }}</h2>
    </div>
  </div>
</template>

<script lang="ts">
import IconComponent from "@/components/IconComponent.vue";
import filters from "@/helpers/filters";
import {
  defineComponent,
  onMounted,
  ref,
  watch,
  nextTick,
  computed,
} from "vue";
import VueApexCharts from "vue3-apexcharts";
import { useSocketStockData } from "@/composables/stock_data.composable";
import { useStockSocket } from "@/composables/stock_socket.composable";
import { useRoute } from "vue-router";
import utilService from "@/services/util.service";

export default defineComponent({
  components: {
    IconComponent,
    apexchart: VueApexCharts,
  },
  props: {
    postId: String,
    class: String,
    trade: Object,
    disableRouting: Boolean,
    showRemove: Boolean,
    FromProfileSocket: {
      type: Boolean,
      defualt: false,
    },
    index: Number,
    samePriceAsCurrent: Boolean,
  },
  emits: ["onRemove", "click", "touchstart"],
  setup(props, context) {
    const marker = ref<any>();
    const lastValue = ref<any>();
    const predicitionData = ref<any>();
    const predicitionAcuurayData = ref<any>();
    const totalDays = ref<any>();
    const daysElapsed = ref<any>();
    const isOverflowing = ref(false);
    const isSymbolOverflowing = ref(false);
    const tradeSymbol = ref<HTMLElement | null>(null);
    const symbolTitle = ref<HTMLElement | null>(null);
    const priceElement = ref<HTMLElement | null>(null);
    const widthCalculating = ref();
    const StockCurrentPrice = ref(
      props.trade!.livePrice ? props.trade!.livePrice : 0
    );
    const series = ref<any>([]);
    let keyIndex = 1;
    const apexKey = ref<string>(`${props.postId}_${keyIndex}`);
    const progressLabelRef = ref(null);
    const predictionType = computed(() => {
      return props.trade.predicition.price > props.trade.price
        ? "Long"
        : "Short";
    });

    const entryChange = computed(() => {
      const entryPrice = props.trade.price;
      const targetPrice = props.trade.predicition.price;

      if (!entryPrice || !targetPrice || entryPrice === 0) {
        return 0;
      }

      let percentage;

      if (predictionType.value === "Long") {
        // For Long: Calculate upward movement percentage
        percentage = ((targetPrice - entryPrice) / entryPrice) * 100;
      } else {
        // For Short: Calculate downward movement percentage (make it positive)
        percentage = ((entryPrice - targetPrice) / entryPrice) * 100;
      }

      if (percentage === Infinity || isNaN(percentage)) {
        return 0;
      }

      return Math.abs(percentage);
    });

    const targetChange = computed(() => {
      let price: any;
      if (props.trade.isOpen) {
        price =
          ((props.trade.predicition.price - stock.value.price) /
            stock.value.price) *
          100;
      } else {
        price =
          ((props.trade.predicition.price - props.trade.livePrice) /
            props.trade.livePrice) *
          100;
      }
      if (price === Infinity) {
        return 0;
      } else {
        return price;
      }
    });

    const { addStockId, checkStockExistence } = useStockSocket();

    const initialObject = () => {
      let obj = {
        _id: props.trade?.stockId,
        type: props.trade?.type,
        symbol: props.trade?.symbol,
        stockId: props.trade?.stockId,
        price: props.trade?.price,
        name: props.trade?.name,
        logoUrl: props.trade?.logoUrl,
        changesPercentage: props.trade?.changesPercentage,
        change: props.trade?.change,
      };
      if (!checkStockExistence(props.trade?.stockId)) {
        addStockId({ showTrendChart: true, stockId: props.trade?.stockId });
      }
      return obj;
    };

    const { stockData: stock, updateStockInfoObject } = useSocketStockData(
      initialObject()
    );

    watch(
      () => props.trade,
      async (newTrade) => {
        if (newTrade && newTrade.predictionId) {
          if (
            predictionIds &&
            !predictionIds.value.includes(newTrade.predictionId)
          ) {
            predictionIds.value.push(newTrade.predictionId);
          }
        }
        if (stock && stock.value) {
          if (props.trade.isOpen === undefined) {
            StockCurrentPrice.value = stock.value!.price;
          }
          if (props.trade!.isOpen) {
            StockCurrentPrice.value = stock.value!.price;
          } else {
            StockCurrentPrice.value = props.trade!.livePrice;
          }
        }
        // predicitionData.value = "";
        // if (props.trade!.predicition && getDateDifference) {
        //   predicitionData.value = getDateDifference(
        //     props.trade!.predicition.date
        //   );
        // }
        // calculateDays();
        updateStockInfoObject(initialObject());
        await nextTick(); // Ensure DOM updates immediately
      },
      { deep: true, immediate: true }
    );

    watch(tradeSymbol, (newValue, oldValue) => {
      if (newValue) {
        checkOverflow();
      }
    });

    watch(symbolTitle, (newValue, oldValue) => {
      if (newValue) {
        checkSymbolOverflow();
      }
    });

    watch(priceElement, () => {
      if (priceElement.value) {
        const width = priceElement.value.offsetWidth;
        widthCalculating.value = width;
      }
    });

    const { getPredictionsByID, predicitionDataInfo, predictionIds } =
      useStockSocket();

    const routeRef = ref<any>(useRoute());

    onMounted(async () => {
      // console.log(props.trade);
      if (props.trade!.predictionId) {
        predictionIds.value.push(props.trade!.predictionId);
        await getPredictionsByID();
        updateTradeChartData();
      }
      // updateSeriesData();
    });

    const updateTradeChartData = (showChart: boolean = false) => {
      const predictionId = props.trade!.predictionId;
      if (predictionId && predicitionDataInfo.value[predictionId]?.fullName) {
        props.trade!.isOpen = predicitionDataInfo.value[predictionId].isOpen;
        // props.trade!.xMax = predicitionDataInfo.value[predictionId].xMax;
        props.trade!.livePrice =
          predicitionDataInfo.value[predictionId].livePrice;
        props.trade!.realizedDate =
          predicitionDataInfo.value[predictionId].realizedDate;
        // keyIndex++;
        // apexKey.value = `${props.postId}_${keyIndex}`;
        // if (series.value.length < 2) {
        //   updateSeriesData();
        // }
      }
    };

    watch(
      () => predicitionDataInfo.value,
      () => {
        updateTradeChartData(true);
      },
      { immediate: true, deep: true }
    );

    const checkOverflow = () => {
      nextTick(() => {
        if (tradeSymbol.value) {
          isOverflowing.value =
            tradeSymbol.value.scrollWidth > tradeSymbol.value.clientWidth;
        }
      });
    };

    const checkSymbolOverflow = () => {
      nextTick(() => {
        if (symbolTitle.value) {
          isSymbolOverflowing.value =
            symbolTitle.value.scrollWidth > symbolTitle.value.clientWidth;
        }
      });
    };

    const calculatedAccuracy = computed(() => {
      if (props.trade && props.trade && props.trade.isOpen) {
        if (
          props.trade?.predicition.price &&
          props.trade?.price &&
          stock.value?.price
        ) {
          let predictedPrice = props.trade?.predicition.price;
          let actualPrice = props.trade?.price;
          let currentPrice = stock.value?.price;
          let res: any = {
            accuracy: 0,
            changeRate: 0,
            isPositive: true,
          };
          if (predictedPrice && actualPrice && currentPrice) {
            res.accuracy =
              ((predictedPrice - currentPrice) / currentPrice) * 100;
            res.changeRate = 0;
            res.isPositive = res.accuracy >= 0;
            return res;
          }
        } else {
          let res: any = {
            accuracy: 0,
            changeRate: 0,
            isPositive: true,
          };
          return res;
        }
      } else {
        if (props.trade && props.trade.predicition) {
          let res: any = {
            accuracy: 0,
            changeRate: 0,
            isPositive: true,
          };
          res.accuracy = props.trade?.predicition.accuracy;
          res.changeRate = props.trade?.predicition.changeRate;
          res.isPositive = props.trade?.predicition.isPositive;
          return res;
        } else {
          let res: any = {
            accuracy: 0,
            changeRate: 0,
            isPositive: true,
          };
          return res;
        }
      }
    });

    const calculateDays = () => {
      const startDate = new Date(props.trade!.tradeDate);
      const predictionDate = new Date(props.trade!.predicition.date);
      if (isNaN(startDate.getTime()) || isNaN(predictionDate.getTime())) {
        console.error("Invalid date detected");
        return;
      }
      const differenceInMilliseconds =
        predictionDate.getTime() - startDate.getTime();
      totalDays.value = Math.ceil(
        differenceInMilliseconds / (24 * 60 * 60 * 1000)
      );
      const now = new Date();
      const elapsedMilliseconds = now.getTime() - startDate.getTime();
      daysElapsed.value = Math.min(
        Math.ceil(elapsedMilliseconds / (24 * 60 * 60 * 1000)),
        totalDays.value
      );
    };

    const getDateDifference = (timestamp: any) => {
      let currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);
      let givenDate = new Date(timestamp);
      givenDate.setHours(0, 0, 0, 0);
      let differenceInTime = givenDate.getTime() - currentDate.getTime();
      let differenceInDays = differenceInTime / (1000 * 3600 * 24);
      differenceInDays = differenceInDays;
      return differenceInDays;
    };

    const onRemove = () => {
      context.emit("onRemove");
    };
    const handleOnClick = () => {
      context.emit("click");
    };
    const handleOnTouchStart = () => {
      context.emit("touchstart");
    };

    onMounted(async () => {
      updateStockInfoObject(initialObject());
      if (props.trade!.isOpen) {
        StockCurrentPrice.value = stock.value!.price;
      } else {
        StockCurrentPrice.value = props.trade!.livePrice;
      }
      checkOverflow();
      checkSymbolOverflow();
      if (props.trade) {
        calculateDays();
        predicitionData.value = "";
        if (props.trade && props.trade.image) {
          props.trade.logoUrl = props.trade.image;
        }
        if (props.trade.predicition) {
          predicitionData.value = getDateDifference(
            props.trade.predicition.date
          );
        }
      }
      if (priceElement.value) {
        const width = priceElement.value.offsetWidth;
        widthCalculating.value = width;
      }
      if (props.trade && props.trade.market) {
        props.trade.type = props.trade.market;
      }
    });

    const chartColor = ref("#B6A0FF");

    const chartType = ref<string>("area");

    const chartOptions = ref<any>(null);

    const formatTradeDate = (timestamp) => {
      let date = new Date(timestamp);
      let day = String(date.getDate()).padStart(2, "0");
      let month = String(date.getMonth() + 1).padStart(2, "0");
      let year = date.getFullYear();
      return `${day}/${month}/${year}`;
    };

    const updateSeriesData = () => {
      var array = props.trade!.chartData ? props.trade!.chartData : [];

      const tradeDateObj = new Date(props.trade!.tradeDate);

      const formattedTradeDate =
        tradeDateObj.getMonth() +
        1 +
        "/" +
        tradeDateObj.getDate() +
        "/" +
        tradeDateObj.getFullYear();

      let findValueIndex = array.findIndex(
        (item: any) => item.x === formattedTradeDate
      );

      if (findValueIndex == -1 && array.length == 0) {
        array.unshift({ x: formattedTradeDate, y: props.trade!.price });
      }

      let predictionPrice = parseFloat(props.trade?.predicition.price);

      const yValue = array.map((data: any) => data.y);

      var findingMinimumPrice = Math.min(...array.map((item: any) => item.y));

      var findingMaximumPrice = Math.max(...array.map((item: any) => item.y));

      var yMin =
        predictionPrice < findingMinimumPrice
          ? predictionPrice
          : findingMinimumPrice;

      var yMax =
        predictionPrice > findingMaximumPrice
          ? predictionPrice
          : findingMaximumPrice;
      const label =
        "$" +
        filters.systemNumberConvention(
          StockCurrentPrice.value,
          true,
          false,
          50,
          true,
          true
        );

      let padding: any;
      if (props.trade.isOpen) {
        padding = 0 * label.length;
      } else {
        padding = 3 * label.length;
      }

      const seriesData = yValue;

      var currentDate = new Date();

      let StartingDateindex = 0;

      let predictionCreatedDate = formatTradeDate(props.trade.tradeDate);
      let findingCreatedDateIndex = array.findIndex(
        (item: any) => item.x === predictionCreatedDate
      );
      if (findingCreatedDateIndex != -1) {
        StartingDateindex = findingCreatedDateIndex;
      } else {
        StartingDateindex = 0;
        // StartingDateindex = array.length - 1;
      }

      const dateObj = new Date(Date.parse(props.trade!.predicition.date));

      const formattedDateInfo =
        dateObj.getMonth() +
        1 +
        "/" +
        dateObj.getDate() +
        "/" +
        dateObj.getFullYear();

      var EndDateindex = array.findIndex(
        (item: any) => item.x === formattedDateInfo
      );

      if (currentDate.getTime() >= dateObj.getTime()) {
        if (EndDateindex == -1) {
          array.push({
            x: formattedDateInfo,
            y: array[seriesData.length - 1].y,
          });

          seriesData.push(array[seriesData.length - 1].y);
        }

        EndDateindex = array.length - 1;

        currentDate = dateObj;
      }

      const formattedDate =
        currentDate.getMonth() +
        1 +
        "/" +
        currentDate.getDate() +
        "/" +
        currentDate.getFullYear();

      var currentDateIndex = array.findIndex(
        (item: any) => item.x === formattedDate
      );

      if (currentDateIndex == -1) {
        currentDateIndex = seriesData.length - 1;
      }

      var dayDifference: any;

      if (props.trade && props.trade.xMax) {
        dayDifference = props.trade.xMax;
      } else {
        dayDifference = seriesData.length;
        if (EndDateindex == -1) {
          dateObj.setHours(0);
          dateObj.setMinutes(0);
          dateObj.setSeconds(0);
          const predicitionDateInfo: any = dateObj.setHours(0);
          const currentPredictionDateInfo: any = new Date();
          currentPredictionDateInfo.setHours(0);
          currentPredictionDateInfo.setMinutes(0);
          currentPredictionDateInfo.setSeconds(0);
          const timeDifference =
            predicitionDateInfo - currentPredictionDateInfo;
          var diff = Math.round(timeDifference / (1000 * 60 * 60 * 24));
          dayDifference = seriesData.length + diff;
          if (dayDifference <= 10) {
            dayDifference = 22;
          }
        }
      }

      chartOptions.value = {
        chart: {
          type: chartType.value,
          height: "100%",
          width: "100%",
          sparkline: {
            enabled: true,
          },
        },
        xaxis: {
          type: "numeric",
          max: dayDifference,
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        yaxis: {
          type: "numeric",
          max: yMax + yMax * 0.05,
          min: yMin - yMax * 0.05,
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        stroke: {
          width: 2,
        },
        fill: {
          gradient: {
            enabled: true,
            opacityFrom: 0.5,
            opacityTo: 0,
          },
        },
        colors: [chartColor.value],
        tooltip: {
          enabled: false,
        },
        annotations: {
          points: [],
        },
        grid: {
          padding: {
            left: 5,
            right: 5,
          },
        },
      };

      var startAnnotation = {
        x: StartingDateindex + 1,
        y: seriesData[StartingDateindex],
        marker: {
          size: 3,
          fillColor: "#FFB21D",
          strokeColor: "#FFB21D",
        },
        label: {
          text: "",
          style: {
            background: "#FFB21D",
            color: "#FFB21D",
          },
        },
      };

      var endAnnotation = {
        x: dayDifference,
        y: props.trade!.predicition.price,
        marker: {
          size: 3,
          fillColor: "#39D3D3",
          strokeColor: "#39D3D3",
        },
      };

      var currentAnnotation = {
        x: currentDateIndex + 1,
        y:
          seriesData[StartingDateindex] == seriesData[currentDateIndex]
            ? seriesData[currentDateIndex] + 4
            : seriesData[currentDateIndex],
        marker: {
          size: 3,
          fillColor: "#B6A0FF",
          strokeColor: "#B6A0FF",
        },
        label: {
          text: label,
          borderColor: "#0C0A14",
          borderWidth: 1,
          offsetY: -5,
          offsetX: currentDateIndex == 0 ? 20 : -padding,
          style: {
            background: "#0C0A14",
            color: "#B6A0FF",
          },
        },
      };

      chartOptions.value.annotations?.points.push(startAnnotation);

      chartOptions.value.annotations?.points.push(currentAnnotation);

      chartOptions.value.annotations?.points.push(endAnnotation);
      if (currentAnnotation.x < endAnnotation.x) {
        var m =
          (endAnnotation.y - currentAnnotation.y) /
          (endAnnotation.x - currentAnnotation.x);
        var c = currentAnnotation.y - m * currentAnnotation.x;
        var count = 0;
        let x = currentAnnotation.x;
        var dotted = true;
        while (x < endAnnotation.x) {
          x += 0.16;
          if (count < 6 && dotted == true) {
            let y = m * x + c;
            var dot = {
              x: x,
              y: y,
              marker: {
                size: 1,
                fillColor: "#934BFF",
                strokeColor: "#934BFF",
                strokeWidth: 0,
              },
            };
            chartOptions.value.annotations?.points.push(dot);
          } else if (count <= 6 && dotted == true) {
            dotted = false;
            count = 0;
          } else if (dotted == false && count < 5) {
            dotted = true;
            count = 0;
          }

          count += 1;
        }
      }

      series.value = [{ data: seriesData }];
    };

    const PredictionCurrentLivePrice = computed(() => {
      let stockPrice = props.trade.livePrice;
      if (props.trade.isOpen) {
        stockPrice = stock.value.price;
      }
      return stockPrice;
    });

    const PredictionAccuracy = computed(() => {
      if (!props.trade.isOpen && props.trade.accuracy) {
        return props.trade.accuracy * 100;
      }

      let stockPrice = PredictionCurrentLivePrice.value;
      if (predictionType.value === "Long") {
        return utilService.progressLong(
          props.trade.price,
          stockPrice,
          props.trade.predicition.price
        );
      }
      return utilService.progressShort(
        props.trade.price,
        stockPrice,
        props.trade.predicition.price
      );
    });

    const PredictionPrice = computed(() => {
      const { isOpen, livePrice } = props.trade;
      if (stock.value) {
        return stock.value.price;
      }
      if (isOpen && stock.value?.price !== undefined) {
        return stock.value.price;
      }

      return livePrice;
    });

    const PredictionChangePercentage = computed(() => {
      const { isOpen, price, livePrice } = props.trade;
      if (stock.value) {
        return stock.value.changesPercentage;
      }

      if (isOpen && stock.value?.changesPercentage !== undefined) {
        return stock.value.changesPercentage;
      }

      if (price === 0) return 0; // Avoid divide-by-zero

      return ((livePrice - price) / price) * 100;
    });

    const progressLabelStyle = computed(() => {
      const leftPercent = PredictionAccuracy.value;
      let leftPosition = leftPercent + "%";
      // Calculate transformX depending on how close to edges
      let translateX = "-50%"; // default center
      let prgressLabelArrowPosition = "";
      let borderRadius = "5px";

      if (leftPercent < 5) {
        // Near 0%, shift less or no shift
        translateX = "0%";
        leftPosition = "-9px";
        prgressLabelArrowPosition = `calc(${leftPercent + "%"} + 12px)`;
        borderRadius = "2px";
      } else if (leftPercent > 95) {
        // Near 100%, shift less or no shift
        leftPosition = "calc(100% + 9px)";
        translateX = "-100%";
        prgressLabelArrowPosition = `calc(${leftPercent + "%"} - 12px)`;
        borderRadius = "2px";
      }

      return {
        left: leftPosition,
        color: `hsl(${(leftPercent / 100) * 120}, 100%, 40%)`,
        transform: `translateX(${translateX})`,
        "--prgressLabelArrowPosition": prgressLabelArrowPosition,
        borderRadius,
      };
    });

    return {
      PredictionPrice,
      PredictionChangePercentage,
      PredictionAccuracy,
      PredictionCurrentLivePrice,
      chartOptions,
      series,
      chartColor,
      chartType,
      apexKey,
      totalDays,
      daysElapsed,
      predictionType,
      entryChange,
      targetChange,
      onRemove,
      getDateDifference,
      marker,
      predicitionData,
      predicitionAcuurayData,
      priceElement,
      stock,
      widthCalculating,
      lastValue,
      isOverflowing,
      tradeSymbol,
      symbolTitle,
      isSymbolOverflowing,
      calculatedAccuracy,
      progressLabelStyle,
      handleOnClick,
      handleOnTouchStart,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "./prediction-chart-card";

$low: var(--color-danger);
$medium: var(--color-warning2);
$high: var(--success-color2);

.accuracy {
  .svg_icon {
    width: 18px;
    height: 18px;
    margin-inline-end: 2px;
    fill: var(--base-text-white);
    opacity: 0.7;
  }

  h3 {
    color: $low !important;
  }

  &.medium {
    h3 {
      color: $medium !important;
    }
  }

  &.high {
    h3 {
      color: $high !important;
    }
  }
}
</style>
